import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { UPDATESTATE } from '../reducers/search-state';
import { SearchService } from '../../common/services/search.service';
import { GaService } from '../../common/services/ga.service';
import * as _ from 'lodash';

@Component({
  selector: 'advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})
export class AdvancedSearchComponent {
  public cityOptionsToShow: number = 10;
  public countyOptionsToShow: number = 10;
  public allCountyOptionsDisplayed: boolean = false;
  public allCityOptionsDisplayed: boolean = false;
  public cityTerm: string;
  public countyTerm: string;
  public stateSelectedAbbr;
  public stateSelected: string;

  @Input() searchStateObj;

  public states = [
    'Alabama',
    'Alaska',
    'American Samoa',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District Of Columbia',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Marshall Islands',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Dakota',
    'Northern Mariana Islands',
    'North Carolina',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virgin Islands',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
  ];
  public statesObj = {
    AL: { name: 'Alabama' },
    AK: { name: 'Alaska' },
    AS: { name: 'American Samoa' },
    AZ: { name: 'Arizona' },
    AR: { name: 'Arkansas' },
    CA: { name: 'California' },
    CO: { name: 'Colorado' },
    CT: { name: 'Connecticut' },
    DE: { name: 'Delaware' },
    DC: { name: 'District Of Columbia' },
    FM: { name: 'Federated States Of Micronesia' },
    FL: { name: 'Florida' },
    GA: { name: 'Georgia' },
    GU: { name: 'Guam' },
    HI: { name: 'Hawaii' },
    ID: { name: 'Idaho' },
    IL: { name: 'Illinois' },
    IN: { name: 'Indiana' },
    IA: { name: 'Iowa' },
    KS: { name: 'Kansas' },
    KY: { name: 'Kentucky' },
    LA: { name: 'Louisiana' },
    ME: { name: 'Maine' },
    MH: { name: 'Marshall Islands' },
    MD: { name: 'Maryland' },
    MA: { name: 'Massachusetts' },
    MI: { name: 'Michigan' },
    MN: { name: 'Minnesota' },
    MS: { name: 'Mississippi' },
    MO: { name: 'Missouri' },
    MT: { name: 'Montana' },
    NE: { name: 'Nebraska' },
    NV: { name: 'Nevada' },
    NH: { name: 'New Hampshire' },
    NJ: { name: 'New Jersey' },
    NM: { name: 'New Mexico' },
    NY: { name: 'New York' },
    NC: { name: 'North Carolina' },
    ND: { name: 'North Dakota' },
    MP: { name: 'Northern Mariana Islands' },
    OH: { name: 'Ohio' },
    OK: { name: 'Oklahoma' },
    OR: { name: 'Oregon' },
    PW: { name: 'Palau' },
    PA: { name: 'Pennsylvania' },
    PR: { name: 'Puerto Rico' },
    RI: { name: 'Rhode Island' },
    SC: { name: 'South Carolina' },
    SD: { name: 'South Dakota' },
    TN: { name: 'Tennessee' },
    TX: { name: 'Texas' },
    UT: { name: 'Utah' },
    VT: { name: 'Vermont' },
    VI: { name: 'Virgin Islands' },
    VA: { name: 'Virginia' },
    WA: { name: 'Washington' },
    WV: { name: 'West Virginia' },
    WI: { name: 'Wisconsin' },
    WY: { name: 'Wyoming' }
  };

  constructor(
    private store: Store<any>,
    private searchService: SearchService,
    private gaService: GaService
  ) {}

  get statePlaceHolder() {
    if (this.searchStateObj.state) {
      return this.searchStateObj.state;
    } else {
      return 'Pick State';
    }
  }

  typeaheadOnSelect(event) {
    this.stateSelectedAbbr = _.findKey(this.statesObj, { name: this.stateSelected });
    this.searchStateObj.isStateSelected = true;
    this.selectState(this.stateSelectedAbbr);
  }

  selectState(stateSelectedAbbr) {
    let searchCriteria = {
      state: stateSelectedAbbr,
      cities: null,
      counties: null,
      searchTerm: this.searchStateObj.searchTerm,
      searchType: this.searchStateObj.searchBy,
      pageNum: 1
    };

    this.searchService.advancedSearch(searchCriteria).subscribe(({ data }) => {
      let cityData = data.search.facet.filter(x => x.name === 'City');
      let countyData = data.search.facet.filter(x => x.name === 'County');

      this.searchStateObj.cities = AdvancedSearchComponent.createArrFiltOpts(cityData);
      this.searchStateObj.counties = AdvancedSearchComponent.createArrFiltOpts(countyData);

      this.store.dispatch({
        type: UPDATESTATE,
        payload: {
          result: data.search.result,
          searchTerm: this.searchStateObj.searchTerm,
          filterResultsBy: this.searchStateObj.filterResultsBy,
          pageNum: 1,
          total: data.search.total,
          searchBy: this.searchStateObj.searchBy,
          typeaheadSuggest: this.searchStateObj.typeaheadSuggest,
          state: this.stateSelected,
          stateSelectedAbbr: this.stateSelectedAbbr,
          cities: this.searchStateObj.cities,
          counties: this.searchStateObj.counties,
          isStateSelected: this.searchStateObj.isStateSelected
        }
      });
    });

    // google analytics
    this.gaService.addAdvancedSearch(
      'advanced',
      this.searchStateObj.searchTerm,
      this.searchStateObj.state,
      '',
      ''
    );
  }

  static createArrFiltOpts(arr) {
    if (arr[0].facetValue !== null) {
      let tempArray = [];

      for (let i = 0; i < arr[0].facetValue.length; i++) {
        let obj = {
          name: arr[0].facetValue[i],
          selected: false
        };
        tempArray.push(obj);
      }
      return tempArray;
    } else {
      return [];
    }
  }

  removeState() {
    this.cityTerm = '';
    this.countyTerm = '';
    this.stateSelected = '';

    let searchCriteria = {
      state: null,
      cities: null,
      counties: null,
      searchTerm: this.searchStateObj.searchTerm,
      searchType: this.searchStateObj.searchBy,
      pageNum: 1
    };

    if (!this.searchStateObj.searchTerm) {
      this.clearSearch();
    } else {
      this.searchService.advancedSearch(searchCriteria).subscribe(({ data }) => {
        this.store.dispatch({
          type: UPDATESTATE,
          payload: {
            result: data.search.result,
            searchTerm: this.searchStateObj.searchTerm,
            filterResultsBy: this.searchStateObj.filterResultsBy,
            pageNum: 1,
            total: data.search.total,
            searchBy: this.searchStateObj.searchBy,
            typeaheadSuggest: this.searchStateObj.typeaheadSuggest,
            state: null,
            stateSelectedAbbr: null,
            cities: null,
            counties: null,
            isStateSelected: false
          }
        });
      });
    }
  }

  clearSearch() {
    this.cityTerm = '';
    this.countyTerm = '';
    this.stateSelected = '';
    this.store.dispatch({
      type: UPDATESTATE,
      payload: {
        total: null,
        result: null,
        pageNum: 1,
        searchTerm: null,
        filterResultsBy: 'All Items',
        searchBy: 'all',
        typeaheadSuggest: 'allSuggest',
        cities: null,
        counties: null,
        isStateSelected: false
      }
    });
  }

  search($event) {
    this.cityTerm = '';
    this.countyTerm = '';

    this.stateSelectedAbbr = _.findKey(this.statesObj, { name: this.stateSelected });
    let citiesSelected = _.filter(this.searchStateObj.cities, function(o) {
      return o.selected;
    }).map(x => x.name);
    let countiesSelected = _.filter(this.searchStateObj.counties, function(o) {
      return o.selected;
    }).map(x => x.name);

    let searchCriteria = {
      state: this.stateSelectedAbbr,
      searchTerm: this.searchStateObj.searchTerm,
      searchType: this.searchStateObj.searchBy,
      cities: citiesSelected,
      counties: countiesSelected,
      pageNum: 1
    };

    this.searchService.advancedSearch(searchCriteria).subscribe(({ data }) => {
      this.store.dispatch({
        type: UPDATESTATE,
        payload: {
          result: data.search.result,
          searchTerm: this.searchStateObj.searchTerm,
          filterResultsBy: this.searchStateObj.filterResultsBy,
          total: data.search.total,
          pageNum: 1,
          searchBy: this.searchStateObj.searchBy,
          typeaheadSuggest: this.searchStateObj.typeaheadSuggest,
          state: this.stateSelected,
          stateSelectedAbbr: this.stateSelectedAbbr,
          cities: this.searchStateObj.cities,
          counties: this.searchStateObj.counties,
          isStateSelected: this.searchStateObj.isStateSelected
        }
      });
    });

    //google analytics
    this.gaService.addAdvancedSearch(
      'advanced',
      this.searchStateObj.searchTerm,
      this.searchStateObj.state,
      citiesSelected,
      countiesSelected
    );
  }

  updateCitiesSelected(option, $event) {
    let ind = this.searchStateObj.cities.indexOf(option);
    this.searchStateObj.cities[ind].selected = !this.searchStateObj.cities[ind].selected;
    this.search($event);
  }

  updateCountiesSelected(option, $event) {
    let ind = this.searchStateObj.counties.indexOf(option);
    this.searchStateObj.counties[ind].selected = !this.searchStateObj.counties[ind].selected;
    this.search($event);
  }

  increaseCityOptionstoShow() {
    this.cityOptionsToShow = this.searchStateObj.cities.length;
    this.allCityOptionsDisplayed = true;
  }

  decreaseCityOptionstoShow() {
    this.cityOptionsToShow = 10;
    this.allCityOptionsDisplayed = false;
  }

  increaseCountyOptionstoShow() {
    this.countyOptionsToShow = this.searchStateObj.counties.length;
    this.allCountyOptionsDisplayed = true;
  }

  decreaseCountyOptionstoShow() {
    this.countyOptionsToShow = 10;
    this.allCountyOptionsDisplayed = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/search/advanced-search/advanced-search.component.ts